import { ThumbsUpIcon } from 'de-suite-me-ui'

export default ThumbsUpIcon
